import PrefacturationFormController from './prefacturation.form.controller';

export default {
    template: require('./prefacturation.form.html'),
    controller: PrefacturationFormController
};
